import { globalState } from '@/state/globalState';
import { createSessionBoundSupabaseClient } from '@/services/supabase';
import { createPartnerMediaResolver, PARTNER_MEDIA_URL_LIFETIME_SECONDS } from './partnerStorageReference';

export const resolveChecklistMediaUri = createPartnerMediaResolver({
  identity: () => {
    const auth = globalState.user.get();
    const userId = auth.user?.id;
    if (!auth.isAuthenticated || !userId || auth.profile?.id !== userId || auth.session?.user?.id !== userId ||
        !auth.profile.empresa_id || !auth.session.access_token) return null;
    return { userId, companyId: auth.profile.empresa_id, sessionKey: auth.session.access_token };
  },
  sign: async (bucket, path, identity) => {
    const { data, error } = await createSessionBoundSupabaseClient(identity.sessionKey).storage
      .from(bucket).createSignedUrl(path, PARTNER_MEDIA_URL_LIFETIME_SECONDS);
    if (error || !data?.signedUrl) throw new Error('Não foi possível carregar a mídia privada.');
    return data.signedUrl;
  },
});
